import { Text } from '@mxenabled/mxui'

import { GridColumnHeaderParams } from '@mui/x-data-grid'

const HeaderCell = (params: GridColumnHeaderParams) => (
  <Text fontWeight={600} variant="body2">
    {params.colDef.headerName}
  </Text>
)

export default HeaderCell
